import { getCurrentViewExportText } from "./export-data";

export function copyData(
  isShowingRawTable,
  result,
  visualizationSettings,
  rawSeries,
) {
  try {
    return getCurrentViewExportText({
      isShowingRawTable,
      result,
      visualizationSettings,
      rawSeries,
    });
  } catch (error) {
    console.error(error);
    return getCurrentViewExportText({
      isShowingRawTable: true,
      result,
      visualizationSettings,
      rawSeries,
    });
  }
}
